export const openSMSApp = () => alert('Opening SMS app');
